import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {RegistrationRoutingModule} from './registration-routing.module';
import {RegistrationComponent} from './registration.component';
import {RegistrationRepository} from './repositories/registration.repository';
import {RegistrationService} from './services/registration.service';
import {PasswordStrengthBarModule} from '../password-strength-bar/password-strenght-bar.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PasswordStrengthBarModule,
    RegistrationRoutingModule,
  ],
  declarations: [
    RegistrationComponent,
  ],
  providers: [
    RegistrationService,
    {
      provide: 'IRegistrationRepository',
      useClass: RegistrationRepository,
    },
  ],
  exports: [
    RegistrationComponent,
  ],
})

export class RegistrationModule { }
